module.exports = __webpack_public_path__ + "static/media/caravan-alt.2d4a0a14.svg";